
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30845',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30845",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55388",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8383",
  "hubspot-dlb": "static-2.1905",
  "HubStyleTokens": "static-2.11838",
  "I18n": "static-7.1680",
  "quartz": "static-1.7513",
  "quartz-config": "static-1.1291",
  "quartz-core": "static-1.6732",
  "react-dlb": "static-1.89",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.81",
  "reselect": "static-3.13",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.968",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55375",
  "feedback-utils": "static-1.55379",
  "forms-embed-utils-lib": "static-1.4810",
  "forms-utils-lib": "static-1.13149",
  "foundations-assets": "static-1.5232",
  "foundations-components": "static-1.8556",
  "foundations-theming": "static-1.4822",
  "hub-http": "static-1.6558",
  "hubspot-url-utils": "static-1.4366",
  "HubStyle": "static-2.12145",
  "icons": "static-2.695",
  "immutable": "static-2.87",
  "quick-fetch": "static-1.4158",
  "raven": "static-3.5925",
  "react": "static-7.196",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.79",
  "react-rhumb": "static-1.17070",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5586",
  "react-virtualized": "static-2.108",
  "redux": "static-4.80",
  "StyleGuideUI": "static-3.508",
  "tinymce-plugins": "static-1.58295",
  "transmute": "static-2.97",
  "ui-images": "static-2.1265",
  "UIComponents": "static-3.8784",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9963",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3790",
  "quartz-webpack": "static-1.3737",
  "foundations-theming-specialty": "static-1.2538",
  "property-description-translator": "static-1.4182",
  "HeadJS": "static-2.804",
  "framer-motion": "static-1.80",
  "hs-test-utils-bend-plugin": "static-1.3494",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4658",
  "jasmine-runner": "static-1.6796",
  "opentelemetry-fe-types": "static-1.123",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.888",
  "hubspotter-http": "static-1.4894",
  "mobile-manifest-mixins": "static-1.584",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.498",
  "quartz-auth": "static-1.1188",
  "quartz-head": "static-1.1178",
  "quartz-i18n": "static-1.1188",
  "quartz-routing": "static-1.943",
  "quartz-test": "static-1.1188",
  "quartz-tracking": "static-1.892",
  "trellis-components": "static-1.2766",
  "ui-fonts": "static-1.1100",
  "usage-tracker-container": "static-1.7649",
  "usage-tracker-core": "static-1.7509",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.235",
  "conversations-skeleton-state": "static-1.7593",
  "reference-resolvers": "static-1.8527",
  "sanitize-text": "static-1.8503",
  "PatternValidationJS": "static-1.3237",
  "ReduxMessenger": "static-2.10716",
  "outpost": "static-1.4498",
  "rpc-client-utils": "static-1.5012",
  "sanitize": "static-1.4818",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4825",
  "floating-ui": "static-1.64",
  "hs-story-utils": "static-1.9771",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.79",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2747",
  "bend-plugin-foundations-theming": "static-1.3305",
  "foundations-theming-base": "static-1.3807",
  "stylex": "static-1.42",
  "hs-locale-management": "static-1.325",
  "csstype": "static-1.50",
  "web-vitals": "static-1.16",
  "ai-components-ui-library": "static-1.9802",
  "atom": "static-1.5428",
  "codemirror": "static-5.103",
  "content-assistance-lib": "static-1.8255",
  "ContentUtils": "static-1.69208",
  "data-token-picker": "static-1.16945",
  "file-manager-components": "static-1.24596",
  "FileManagerCore": "static-1.40095",
  "FileManagerLib": "static-1.40236",
  "frontend-preferences-client": "static-1.8265",
  "hub-http-contrib": "static-1.3386",
  "interframe": "static-3.5101",
  "layout-dnd-components": "static-1.13030",
  "layout-dnd-utils": "static-1.12005",
  "property-translator": "static-1.5739",
  "react-codemirror": "static-1.10989",
  "react-colorpicker": "static-2.10559",
  "reference-resolvers-lite": "static-1.8450",
  "rich-text-lib": "static-1.20365",
  "tinymce-data": "static-1.41266",
  "tinymce-themes": "static-1.57151",
  "ui-addon-emoji-picker": "static-1.10230",
  "ui-addon-sales-email": "static-1.5560",
  "ui-brand-identity-lib": "static-1.16642",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.50",
  "hub-http-shared-msw-handlers": "static-1.10689",
  "hubspotter-http-shared-msw-handlers": "static-1.10687",
  "usage-tracker-session-replay": "static-1.5345",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "trellis-theming": "static-1.1319",
  "tanstack-virtual": "static-1.39",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.422",
  "chirp-fetch": "static-1.2242",
  "stylex-utils": "static-1.148",
  "chatspot-core": "static-1.23207",
  "copilot-toolkit": "static-1.11919",
  "customer-data-objects-ui-components": "static-1.13377",
  "data-fetching-client": "static-1.9998",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5105",
  "ui-addon-video-player": "static-1.9048",
  "ui-coaching-tips": "static-1.29384",
  "usage-tracker": "static-1.7659",
  "cms-field-types": "static-1.5158",
  "content-icons-ui": "static-1.2409",
  "integrations-lib": "static-1.17152",
  "customer-data-objects": "static-1.8044",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1846",
  "apollo-link-hub-http": "static-2.5003",
  "apollo-stack-hubspot": "static-3.95",
  "graphql": "static-1.90",
  "immer": "static-1.102",
  "immerable": "static-1.4492",
  "ui-addon-iframeable": "static-1.9423",
  "video-components-external": "static-1.12221",
  "video-data-lib": "static-1.35879",
  "breeze-artifacts-sdk": "static-1.476",
  "audio-components": "static-1.6402",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29869",
  "FileManagerImages": "static-1.37747",
  "foundations-components-legacy": "static-1.1581",
  "html-to-image": "static-1.62",
  "redux-toolkit": "static-1.79",
  "salesImages": "static-1.606",
  "ui-universal-auth": "static-1.9480",
  "urlinator": "static-1.4876",
  "video-components": "static-1.14223",
  "video-embed": "static-1.36713",
  "ts-schema": "static-1.4324",
  "ContentData": "static-1.69283",
  "layout-data-lib": "static-1.10330",
  "react-dnd-compat": "static-1.4962",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1891",
  "external-options-client-types": "static-1.4371",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7239",
  "hs-promise-utils": "static-1.5936",
  "inbound-db-properties-service-client": "static-1.4078",
  "NamespacedHubStyle": "static-2.9294",
  "growth-onboarding-confetti": "static-1.3411",
  "SharedI18nStrings": "static-1.183",
  "ui-addon-i18n": "static-1.11492",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5788",
  "magpie-types": "static-1.5248",
  "simple-logging-lib": "static-1.3397",
  "avatar-components": "static-1.2828",
  "customer-data-ui-utilities": "static-1.10177",
  "growth-onboarding-feedback-components": "static-1.6931",
  "flux-actions": "static-1.374",
  "hubspot-apollo-client": "static-1.5223",
  "integrations-error-boundary-lib": "static-1.14567",
  "integrations-tracking-lib": "static-1.5954",
  "laboratory-lib": "static-3.7499",
  "native-integrations-shared-strings": "static-1.8123",
  "redux-observable": "static-1.76",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10616",
  "unified-auth": "static-1.994",
  "breeze-engine-chat-components": "static-1.824",
  "breeze-engine-core": "static-1.1124",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "pulse": "static-1.976",
  "navigation-messaging": "static-1.8237",
  "content-media-composition-data-lib": "static-1.13333",
  "content-media-compositions": "static-2.17340",
  "idb-keyval": "static-1.52",
  "media-bridge-lib": "static-1.19462",
  "unified-auth-core-lib": "static-1.1276",
  "social-insights-client-types": "static-1.22714",
  "advanced-menus-core": "static-1.15636",
  "advanced-menus-lib": "static-1.12504",
  "ExportDialog": "static-6.10724",
  "ui-memberships-settings-lib": "static-1.34918",
  "conditional-properties-service-client": "static-1.4047",
  "crm-pipelines-api-client-types": "static-1.4378",
  "fdsr-migration-layer": "static-1.358",
  "framework-builder-read-service-client": "static-1.4252",
  "framework-data-schema-quick-fetch": "static-1.7144",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3938",
  "persist-promise": "static-1.4048",
  "foundations-components-test-utils": "static-1.6039",
  "reactive-lib": "static-1.1065",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.682",
  "universal-page-editor-lib": "static-1.3354",
  "adobe-sign-auth-lib": "static-1.543",
  "ads-unified-auth-lib": "static-1.1512",
  "custom-vendor-connection-lib": "static-1.44",
  "google-sheets-integration-lib": "static-1.1107",
  "microsoft-drive-auth-lib": "static-1.227",
  "surveymonkey-integration-lib": "static-1.568",
  "slack-ui-library": "static-1.10745",
  "bend-plugin-pulse": "static-1.479",
  "event-emitter": "static-1.1302",
  "fast-json-patch": "static-1.71",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4099",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15635",
  "simple-menus-lib": "static-1.17152",
  "settings-ui-lib": "static-1.12870",
  "crm-record-cards-service-types": "static-1.3796",
  "location-customization-utils-lib": "static-1.10182",
  "react-flip-move": "static-1.79"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30845",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55388",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8383",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "HubStyleTokens": "/HubStyleTokens/static-2.11838",
  "I18n": "/I18n/static-7.1680",
  "quartz": "/quartz/static-1.7513",
  "quartz-config": "/quartz-config/static-1.1291",
  "quartz-core": "/quartz-core/static-1.6732",
  "react-dlb": "/react-dlb/static-1.89",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.81",
  "reselect": "/reselect/static-3.13",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.968",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55375",
  "feedback-utils": "/feedback-utils/static-1.55379",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4810",
  "forms-utils-lib": "/forms-utils-lib/static-1.13149",
  "foundations-assets": "/foundations-assets/static-1.5232",
  "foundations-components": "/foundations-components/static-1.8556",
  "foundations-theming": "/foundations-theming/static-1.4822",
  "hub-http": "/hub-http/static-1.6558",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyle": "/HubStyle/static-2.12145",
  "icons": "/icons/static-2.695",
  "immutable": "/immutable/static-2.87",
  "quick-fetch": "/quick-fetch/static-1.4158",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.196",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.79",
  "react-rhumb": "/react-rhumb/static-1.17070",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5586",
  "react-virtualized": "/react-virtualized/static-2.108",
  "redux": "/redux/static-4.80",
  "StyleGuideUI": "/StyleGuideUI/static-3.508",
  "tinymce-plugins": "/tinymce-plugins/static-1.58295",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1265",
  "UIComponents": "/UIComponents/static-3.8784",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9963",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3790",
  "quartz-webpack": "/quartz-webpack/static-1.3737",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2538",
  "property-description-translator": "/property-description-translator/static-1.4182",
  "HeadJS": "/HeadJS/static-2.804",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3494",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4658",
  "jasmine-runner": "/jasmine-runner/static-1.6796",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.123",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.888",
  "hubspotter-http": "/hubspotter-http/static-1.4894",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.584",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.498",
  "quartz-auth": "/quartz-auth/static-1.1188",
  "quartz-head": "/quartz-head/static-1.1178",
  "quartz-i18n": "/quartz-i18n/static-1.1188",
  "quartz-routing": "/quartz-routing/static-1.943",
  "quartz-test": "/quartz-test/static-1.1188",
  "quartz-tracking": "/quartz-tracking/static-1.892",
  "trellis-components": "/trellis-components/static-1.2766",
  "ui-fonts": "/ui-fonts/static-1.1100",
  "usage-tracker-container": "/usage-tracker-container/static-1.7649",
  "usage-tracker-core": "/usage-tracker-core/static-1.7509",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.235",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7593",
  "reference-resolvers": "/reference-resolvers/static-1.8527",
  "sanitize-text": "/sanitize-text/static-1.8503",
  "PatternValidationJS": "/PatternValidationJS/static-1.3237",
  "ReduxMessenger": "/ReduxMessenger/static-2.10716",
  "outpost": "/outpost/static-1.4498",
  "rpc-client-utils": "/rpc-client-utils/static-1.5012",
  "sanitize": "/sanitize/static-1.4818",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4825",
  "floating-ui": "/floating-ui/static-1.64",
  "hs-story-utils": "/hs-story-utils/static-1.9771",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.79",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2747",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3305",
  "foundations-theming-base": "/foundations-theming-base/static-1.3807",
  "stylex": "/stylex/static-1.42",
  "hs-locale-management": "/hs-locale-management/static-1.325",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.16",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9802",
  "atom": "/atom/static-1.5428",
  "codemirror": "/codemirror/static-5.103",
  "content-assistance-lib": "/content-assistance-lib/static-1.8255",
  "ContentUtils": "/ContentUtils/static-1.69208",
  "data-token-picker": "/data-token-picker/static-1.16945",
  "file-manager-components": "/file-manager-components/static-1.24596",
  "FileManagerCore": "/FileManagerCore/static-1.40095",
  "FileManagerLib": "/FileManagerLib/static-1.40236",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8265",
  "hub-http-contrib": "/hub-http-contrib/static-1.3386",
  "interframe": "/interframe/static-3.5101",
  "layout-dnd-components": "/layout-dnd-components/static-1.13030",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12005",
  "property-translator": "/property-translator/static-1.5739",
  "react-codemirror": "/react-codemirror/static-1.10989",
  "react-colorpicker": "/react-colorpicker/static-2.10559",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8450",
  "rich-text-lib": "/rich-text-lib/static-1.20365",
  "tinymce-data": "/tinymce-data/static-1.41266",
  "tinymce-themes": "/tinymce-themes/static-1.57151",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10230",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5560",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16642",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.50",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10689",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10687",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5345",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "trellis-theming": "/trellis-theming/static-1.1319",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.422",
  "chirp-fetch": "/chirp-fetch/static-1.2242",
  "stylex-utils": "/stylex-utils/static-1.148",
  "chatspot-core": "/chatspot-core/static-1.23207",
  "copilot-toolkit": "/copilot-toolkit/static-1.11919",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13377",
  "data-fetching-client": "/data-fetching-client/static-1.9998",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5105",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9048",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29384",
  "usage-tracker": "/usage-tracker/static-1.7659",
  "cms-field-types": "/cms-field-types/static-1.5158",
  "content-icons-ui": "/content-icons-ui/static-1.2409",
  "integrations-lib": "/integrations-lib/static-1.17152",
  "customer-data-objects": "/customer-data-objects/static-1.8044",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1846",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5003",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
  "graphql": "/graphql/static-1.90",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4492",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9423",
  "video-components-external": "/video-components-external/static-1.12221",
  "video-data-lib": "/video-data-lib/static-1.35879",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.476",
  "audio-components": "/audio-components/static-1.6402",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29869",
  "FileManagerImages": "/FileManagerImages/static-1.37747",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1581",
  "html-to-image": "/html-to-image/static-1.62",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "salesImages": "/salesImages/static-1.606",
  "ui-universal-auth": "/ui-universal-auth/static-1.9480",
  "urlinator": "/urlinator/static-1.4876",
  "video-components": "/video-components/static-1.14223",
  "video-embed": "/video-embed/static-1.36713",
  "ts-schema": "/ts-schema/static-1.4324",
  "ContentData": "/ContentData/static-1.69283",
  "layout-data-lib": "/layout-data-lib/static-1.10330",
  "react-dnd-compat": "/react-dnd-compat/static-1.4962",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1891",
  "external-options-client-types": "/external-options-client-types/static-1.4371",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7239",
  "hs-promise-utils": "/hs-promise-utils/static-1.5936",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4078",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9294",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3411",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.183",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11492",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5788",
  "magpie-types": "/magpie-types/static-1.5248",
  "simple-logging-lib": "/simple-logging-lib/static-1.3397",
  "avatar-components": "/avatar-components/static-1.2828",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10177",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6931",
  "flux-actions": "/flux-actions/static-1.374",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5223",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14567",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5954",
  "laboratory-lib": "/laboratory-lib/static-3.7499",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8123",
  "redux-observable": "/redux-observable/static-1.76",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10616",
  "unified-auth": "/unified-auth/static-1.994",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.824",
  "breeze-engine-core": "/breeze-engine-core/static-1.1124",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "pulse": "/pulse/static-1.976",
  "navigation-messaging": "/navigation-messaging/static-1.8237",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13333",
  "content-media-compositions": "/content-media-compositions/static-2.17340",
  "idb-keyval": "/idb-keyval/static-1.52",
  "media-bridge-lib": "/media-bridge-lib/static-1.19462",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1276",
  "social-insights-client-types": "/social-insights-client-types/static-1.22714",
  "advanced-menus-core": "/advanced-menus-core/static-1.15636",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12504",
  "ExportDialog": "/ExportDialog/static-6.10724",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34918",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4047",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4378",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.358",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4252",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7144",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3938",
  "persist-promise": "/persist-promise/static-1.4048",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6039",
  "reactive-lib": "/reactive-lib/static-1.1065",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.682",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3354",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.543",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1512",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.44",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1107",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.227",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.568",
  "slack-ui-library": "/slack-ui-library/static-1.10745",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.479",
  "event-emitter": "/event-emitter/static-1.1302",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4099",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15635",
  "simple-menus-lib": "/simple-menus-lib/static-1.17152",
  "settings-ui-lib": "/settings-ui-lib/static-1.12870",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10182",
  "react-flip-move": "/react-flip-move/static-1.79"
}
};
